export default __webpack_public_path__ + "static/node_runner_mobile@2x-893f7747c2bb8427d6fba8f0f6ad23d9.png";